import { render, staticRenderFns } from "./ActionDownloadVcf.vue?vue&type=template&id=3792afd0&scoped=true&"
import script from "./ActionDownloadVcf.vue?vue&type=script&lang=js&"
export * from "./ActionDownloadVcf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3792afd0",
  null
  
)

export default component.exports